import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import UsersList, { usersListLoader } from "./List";
import UsersDetail, { usersDetailLoader } from "./Detail";

export const usersRoutes: RouteObject[] = [
  { path: "users", Component: UsersList, loader: usersListLoader, errorElement: <AppError /> },
  { path: "users/:userNumber", Component: UsersDetail, loader: usersDetailLoader, errorElement: <AppError /> },
];
